// extracted by mini-css-extract-plugin
export default {"titleComment":"SportsBioSecurityFormPlayerBioSecurityForm_titleComment","redText":"SportsBioSecurityFormPlayerBioSecurityForm_redText"};